import { render, staticRenderFns } from "./StatsBand.vue?vue&type=template&id=7a82b625&"
import script from "./StatsBand.vue?vue&type=script&lang=js&"
export * from "./StatsBand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports